import { useTranslation } from 'react-i18next';

import styles from './Skeleton.module.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  /**
   * Ogłoś ładowanie czytnikowi ekranu. Domyślnie NIE — przy dziesięciu
   * szkieletach na ekranie dziesięć ogłoszeń to hałas. Ustawiamy `true`
   * na jednym, reprezentatywnym elemencie obszaru.
   */
  announce?: boolean;
}

export function Skeleton({ width = '100%', height = '1rem', announce = false }: SkeletonProps) {
  const { t } = useTranslation();

  return (
    <span
      className={styles['skeleton']}
      style={{ width, height }}
      {...(announce
        ? { role: 'status', 'aria-label': t('common.state.loading') }
        : { 'aria-hidden': true })}
    />
  );
}
